.root {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: min-content;
  padding: 0.25rem;
}

.header {
  display: flex;
  gap: 0.5rem;
  align-items: center;
  justify-content: space-between;
}

.action {
  width: 36px;
  height: 36px;
  cursor: pointer;

  svg {
    width: 1.5rem;
    height: 1.5rem;
  }
}

.monthAndYear {
  font-size: 14px;
}

.pushRight {
  margin-left: auto;
}

.footer {
  display: flex;
  justify-content: space-between;
  min-height: 1em;
  margin-top: 0.5rem;
  font-size: 14px;

  span {
    font-weight: var(--font-weight-regular);
  }
}
